<div *ngIf="selectedCompany" class="d-inline-block" ngbDropdown>
  <div class="company-container" ngbDropdownToggle>
    <!-- <div
      class="companyImage"
      [style]="getCompanyImage()"
      (click)="showChangeImageModal()"
    ></div> -->

    <div
      class="companyInfo"
      placement="bottom"
      [ngbTooltip]="selectedCompany.name"
    >
      <span id="selectCompany">
        <p>{{ selectedCompany.name.length > 25 ? (selectedCompany.name | slice:0:25) + '...' : selectedCompany.name }}</p>
        <p>{{ selectedCompany.nif }}</p>
      </span>
    </div>
  </div>

  <div class="w-100">
    <div class="col-12 test" ngbDropdownMenu aria-labelledby="selectCompany">
      <!-- Search Input -->
      <input
        type="text"
        class="form-control mb-2"
        placeholder="Procurar por nome ou NIF..."
        [(ngModel)]="searchText"
      />

      <!-- Filtered Company List -->
      <button
        *ngFor="let company of filteredCompanies"
        ngbDropdownItem
        (click)="updateCompany(company)"
        [title]="company.name"
      >
        {{ company.name }}
      </button>
    </div>
  </div>
</div>

<!-- Modal Change Company Image -->
<ng-template #updateCompanyImageContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">
      <span>Atualizar imagem da empresa</span>
    </h5>
    <button
      type="button"
      class="close"
      (click)="modal.close('by: close icon')"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-update-company-image
      [company]="selectedCompany"
    ></app-update-company-image>
  </div>
</ng-template>
